import { makeStyles } from '@fluentui/react-components';
import { RotateLeft } from '@material-symbols-svg/react/rounded/w500';

import { palette, tokens, useAppButtonStyles } from '../theme';

export type DialogFooterProps = {
    pendingCount: number;
    onReset: () => void;
    onClose: () => void;
};

// Entries stay pending until synced, so closing the dialog keeps them.
export const DialogFooter: React.FC<DialogFooterProps> = ({ pendingCount, onReset, onClose }) => {
    const classes = useStyles();
    const buttons = useAppButtonStyles();
    const canReset = pendingCount > 0;

    return (
        <div className={classes.root}>
            {pendingCount > 0 && (
                <div className={classes.unsaved}>
                    <span className={classes.unsavedDot} />
                    <span className={classes.unsavedText}>
                        {pendingCount} unsaved {pendingCount === 1 ? 'change' : 'changes'}
                    </span>
                </div>
            )}
            <div className={classes.actions}>
                <button
                    type="button"
                    className={buttons.secondary}
                    disabled={!canReset}
                    onClick={onReset}
                    aria-label={`Reset ${pendingCount} pending ${pendingCount === 1 ? 'entry' : 'entries'}`}
                >
                    <RotateLeft className={classes.icon} aria-hidden />
                    <span>Reset</span>
                </button>
                <button type="button" className={buttons.secondary} onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
    },
    unsaved: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
    },
    unsavedDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: palette.pendingAccent,
    },
    unsavedText: {
        fontSize: '12.5px',
        color: tokens.colorNeutralForeground2,
    },
    actions: {
        display: 'inline-flex',
        gap: '8px',
        marginLeft: 'auto',
    },
    icon: {
        width: '16px',
        height: '16px',
    },
});
